import { useEffect, useState } from 'react';
import { Modal } from 'antd';
import { AlertFilled } from 'patternx-svg';
// import './index.less';
import * as api from '@/services/enterprise';

const UpdateAuthorizationCode = (props: any) => {
  const { handleAlertOK, handleAlertCancel } = props;

  return (
    <>
      <Modal
        title="编辑授权码"
        visible={true}
        onOk={() => handleAlertOK()}
        onCancel={handleAlertCancel}
        width={400}
      >
        <div>
          <div style={{ display: 'flex' }}>
            <AlertFilled
              style={{
                width: '20px',
                height: '20px',
                color: 'rgba(215,81,66,1)',
                lineHeight: '24px',
                margin: '10px 14px',
              }}
            />
            <div style={{ color: '#1d1d29', fontSize: '16px', lineHeight: '40px', height: '40px' }}>
              确定停用授权码吗？
            </div>
          </div>
          <div style={{ color: '#5f6173', fontSize: '14px', marginLeft: '49px' }}>
            授权码停用后不可编辑使用
          </div>
        </div>
      </Modal>
    </>
  );
};

export default UpdateAuthorizationCode;
